const dialogApi = Symbol('dialogApiKey');

export default dialogApi;
